import {
  AUTHORIZE_THIRD,
  CHANGE_DISPATCH_ADDRESS,
  REPORT_PAGE_ERROR,
  REPORT_PURCHASE_ERROR,
  REQUEST_BILL_IMAGE,
  REQUEST_BLOCK_CARD,
  REQUEST_CHANGE_RIPLEYCARD,
  REQUEST_EXTEND_GIFT_CARD,
  REQUEST_EXTEND_GIFT_CARD_COMPANY,
  REQUEST_INSURANCES_INFORMATION,
  REQUEST_PAY_ACCOUNT,
  REQUEST_RPGO_INFORMATION,
  SILVER_GOLD_PAYMENT,
  BAD_STATE,
  ARRIVED_INCOMPLETE,
  NOT_WORKING,
  PRODUCT_CHANGE,
  ANOTHER_PRODUCT,
  ASSEMBLE_PRODUCT,
  ALARM_IN_PRODUCT,
  CANCEL_PURCHASE,
  CANCELLATION_PURCHASE_STATUS,
  REPORT_GIFTCARD_PROBLEM,
  GENERAL_CLUBS_PROBLEMS,
  NOT_RECEIVED,
} from '../constants/Routes';

let IssueMapper = new Map();
IssueMapper.set('28', AUTHORIZE_THIRD);
IssueMapper.set('10', CHANGE_DISPATCH_ADDRESS);
IssueMapper.set('29', SILVER_GOLD_PAYMENT);
IssueMapper.set('6', BAD_STATE);
IssueMapper.set('4', ARRIVED_INCOMPLETE);
IssueMapper.set('5', NOT_WORKING);
IssueMapper.set('35', PRODUCT_CHANGE);
IssueMapper.set('37', ALARM_IN_PRODUCT);
IssueMapper.set('3', ANOTHER_PRODUCT);
IssueMapper.set('9', ASSEMBLE_PRODUCT);
IssueMapper.set('7', CANCEL_PURCHASE);
IssueMapper.set('11', CANCELLATION_PURCHASE_STATUS);
IssueMapper.set('2', NOT_RECEIVED);

export const notProductIssueMapper = (value) => {
  switch (value) {
    case 25:
      return REQUEST_BLOCK_CARD;
    case 12:
      return REQUEST_CHANGE_RIPLEYCARD;
    case 24:
      return REQUEST_PAY_ACCOUNT;
    case 20:
      return REQUEST_RPGO_INFORMATION;
    case 23:
      return REQUEST_INSURANCES_INFORMATION;
    case 18:
      return REQUEST_BILL_IMAGE;
    case 33:
      return REPORT_PAGE_ERROR;
    case 17:
      return REPORT_PURCHASE_ERROR;
    case 31:
      return REQUEST_EXTEND_GIFT_CARD;
    case 32:
      return REQUEST_EXTEND_GIFT_CARD_COMPANY;
    case 36:
      return REPORT_GIFTCARD_PROBLEM;
    case 'general-clubs':
      return GENERAL_CLUBS_PROBLEMS;
    default:
      return '';
  }
};

export default IssueMapper;
